import React, { FC } from "react";

interface SodastreamLogoProps {
  color: string;
  width: string;
}

const SodastreamLogo: FC<SodastreamLogoProps> = ({ color, width }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 157.938 32"
      style={{ width }}
    >
      <defs>
        <clipPath id="49fmqvt0ha">
          <path
            data-name="Rectangle 725"
            style={{ fill: color }}
            d="M0 0h157.938v32H0z"
          ></path>
        </clipPath>
      </defs>
      <g data-name="Group 3558" style={{ clipPath: "url(#49fmqvt0ha)" }}>
        <path
          data-name="Path 13073"
          d="M407.71 4.458c0-.144-.063-.316-.365-.316h-.411v1.047h.2V4.77h.126l.276.419h.211l-.29-.436a.283.283 0 0 0 .253-.295m-.576.125v-.254h.183c.138 0 .192.034.192.123 0 .113-.073.132-.236.132zm.154-1.075a1.151 1.151 0 1 0 1.151 1.151 1.15 1.15 0 0 0-1.151-1.151m0 2.116a.965.965 0 1 1 .946-.965.954.954 0 0 1-.946.965M340.9 14.779c0 2.322-2.138 4.063-4.99 4.063-3.06 0-5.234-1.527-5.609-4.135h2.838a2.473 2.473 0 0 0 2.616 1.6c1.423 0 2.269-.605 2.269-1.5 0-2.775-7.468-.531-7.468-5.436 0-2.244 1.872-3.96 4.881-3.96 2.814 0 4.81 1.433 5.235 3.861h-2.987c-.2-.745-.852-1.409-2.3-1.409-1.161 0-1.978.5-1.978 1.32 0 2.612 7.5.212 7.5 5.6m4.2-12.407h-2.853v11.545c0 3.159 1.834 4.9 4.584 4.9a4.658 4.658 0 0 0 1.528-.246v-2.556a2.281 2.281 0 0 1-.917.17 2.089 2.089 0 0 1-2.343-2.273V8.3h3.26V5.683H345.1zm-66.772 6.641c0-1.169 1.1-2.08 2.717-2.08a2.72 2.72 0 0 1 2.926 2.363h1.567a4.155 4.155 0 0 0-4.5-3.884c-2.173 0-4.282 1.262-4.282 3.619 0 4.976 7.514 2.469 7.514 5.992 0 1.038-.919 2.294-3 2.294-1.648 0-3.2-.927-3.2-2.605h-1.569c0 2.483 2.06 4.131 4.774 4.131 3.027 0 4.563-1.977 4.563-3.815 0-5.217-7.513-2.735-7.513-6.011m50.411-3.333V18.57h-1.552v-2.228a6.256 6.256 0 0 1-5.155 2.5 6.62 6.62 0 0 1-6.669-6.716 6.62 6.62 0 0 1 6.669-6.716 6.256 6.256 0 0 1 5.155 2.5V5.683zm-1.543 6.439a5.078 5.078 0 0 0-5.112-5.19 5.19 5.19 0 0 0 0 10.379 5.078 5.078 0 0 0 5.112-5.19m-12.907-9.754v16.2h-1.552v-2.23a6.255 6.255 0 0 1-5.155 2.5 6.62 6.62 0 0 1-6.669-6.716 6.62 6.62 0 0 1 6.669-6.716 6.255 6.255 0 0 1 5.155 2.5V2.372zm-1.547 9.755a5.078 5.078 0 0 0-5.112-5.19 5.19 5.19 0 0 0 0 10.379 5.078 5.078 0 0 0 5.112-5.19M382.3 5.683h2.735V18.57H382.3v-1.322a5.936 5.936 0 0 1-4.182 1.594 6.588 6.588 0 0 1-6.574-6.716 6.588 6.588 0 0 1 6.574-6.716A5.937 5.937 0 0 1 382.3 7zm.093 6.443a3.99 3.99 0 0 0-4.077-4.07 4.071 4.071 0 0 0 0 8.141 3.99 3.99 0 0 0 4.077-4.07m-82.307 0a6.716 6.716 0 1 1-6.716-6.716 6.66 6.66 0 0 1 6.716 6.716m-1.585 0a5.131 5.131 0 1 0-5.131 5.19 5.173 5.173 0 0 0 5.131-5.19m58.905-6.7a4.723 4.723 0 0 0-4.38 2V5.683H350.3V18.57h2.827v-5.277a10.07 10.07 0 0 1 .2-2.5 3.763 3.763 0 0 1 4.086-2.645zm13.219 6.7a8.516 8.516 0 0 1-.06.988H360.2a3.713 3.713 0 0 0 3.808 3.1 3.381 3.381 0 0 0 3.221-1.505h3.086a6.275 6.275 0 0 1-6.306 4.131 6.716 6.716 0 1 1 0-13.431 6.431 6.431 0 0 1 6.622 6.716m-10.338-1.364h7.331A3.419 3.419 0 0 0 364 8.043a3.687 3.687 0 0 0-3.715 2.72m46.109-.138c0-2.763-1.664-5.214-4.869-5.214a5.185 5.185 0 0 0-4.361 2.027 4.29 4.29 0 0 0-3.689-2.027 5 5 0 0 0-3.84 1.621V5.683h-2.758V18.57h2.852v-7.03a5.09 5.09 0 0 1 .2-1.628 2.706 2.706 0 0 1 2.571-1.827c1.873 0 2.716 1.206 2.716 3.034v7.451h2.852v-7.048a5.052 5.052 0 0 1 .2-1.61 2.706 2.706 0 0 1 2.563-1.827c1.873 0 2.716 1.206 2.716 3.034v7.451h2.853z"
          transform="translate(-250.501 -2.149)"
          style={{ fill: color }}
        ></path>
        <path
          data-name="Path 13074"
          d="M0 9.616a9.616 9.616 0 1 1 9.616 9.616A9.616 9.616 0 0 1 0 9.616m16.811 1.492q.007-.195.007-.4A7.341 7.341 0 0 0 9.6 3.089c-2.555 0-4.442 1.217-4.442 3.048 0 1 .6 2.142 2.6 2.142 1.338 0 2.251-.444 3.889-.444a5.43 5.43 0 0 1 5.169 3.274m-2.74 1.991c0-1-.6-2.142-2.6-2.142-1.338 0-2.251.444-3.889.444A5.43 5.43 0 0 1 2.42 8.124q-.006.195-.006.4a7.341 7.341 0 0 0 7.22 7.621c2.555 0 4.442-1.217 4.442-3.048m-.893 4.447a4.79 4.79 0 0 0 3.061-4.444 4.327 4.327 0 0 0-4.6-4.345c-1.535 0-2.43.444-3.889.444C5.242 9.2 4.23 7.652 4.23 6.136c0-2.276 2.154-3.973 5.37-3.973a8.266 8.266 0 0 1 8.145 8.546 9.515 9.515 0 0 1-.414 2.914A8.694 8.694 0 0 0 6.048 1.689a4.79 4.79 0 0 0-3.061 4.439 4.327 4.327 0 0 0 4.6 4.345c1.535 0 2.43-.444 3.889-.444C13.989 10.028 15 11.579 15 13.1c0 2.276-2.154 3.973-5.367 3.973a8.266 8.266 0 0 1-8.144-8.551A9.515 9.515 0 0 1 1.9 5.608a8.695 8.695 0 0 0 11.283 11.935"
          style={{ fill: color }}
        ></path>
        <g data-name="Group 3560">
          <path
            data-name="Path 13075"
            d="M279.1 277.37a3.731 3.731 0 0 1 2.307.477 1.623 1.623 0 0 1 .6 1.294 1.647 1.647 0 0 1-.57 1.3 2.711 2.711 0 0 1-1.737.477h-2.02v2.239h-1.209v-5.787zm-1.42 2.63h1.592a2.689 2.689 0 0 0 1.03-.145.73.73 0 0 0 .443-.715.7.7 0 0 0-.426-.706 2.641 2.641 0 0 0-1.03-.145h-1.609z"
            transform="translate(-250.464 -253.888)"
            style={{ fill: color }}
          ></path>
          <path
            data-name="Path 13076"
            d="M380.951 280.741c0 1.856-.911 2.537-2.877 2.537s-2.869-.681-2.869-2.537v-3.371h1.218v3.33c0 1.141.366 1.643 1.652 1.643s1.66-.485 1.66-1.643v-3.33h1.217z"
            transform="translate(-339.91 -253.888)"
            style={{ fill: color }}
          ></path>
          <path
            data-name="Path 13077"
            d="M479.781 282.277c-1.754 0-2.775-.681-3.124-1.5l1.115-.4a2.115 2.115 0 0 0 2.035.962c.979 0 1.549-.29 1.549-.783 0-.443-.443-.562-1.328-.715l-.877-.162c-1.252-.23-2.23-.6-2.23-1.66 0-1.115 1.124-1.737 2.716-1.737 1.413 0 2.486.5 2.826 1.294l-1.047.392a2.049 2.049 0 0 0-1.8-.758c-.894 0-1.4.273-1.4.707 0 .417.357.519 1.337.715l1.107.221c1.234.247 1.984.6 1.984 1.618 0 1.234-1.251 1.8-2.86 1.8"
            transform="translate(-431.819 -252.904)"
            style={{ fill: color }}
          ></path>
          <path
            data-name="Path 13078"
            d="M582.269 283.159v-5.789h1.209v2.33h3.541v-2.33h1.209v5.789h-1.209v-2.528h-3.541v2.528z"
            transform="translate(-527.496 -253.888)"
            style={{ fill: color }}
          ></path>
          <path
            data-name="Path 13079"
            d="M746.8 283.159v-5.789h4.878v.928h-3.669v1.447h3.5v.919h-3.5v2.494z"
            transform="translate(-676.547 -253.888)"
            style={{ fill: color }}
          ></path>
          <path
            data-name="Path 13080"
            d="M835.577 279.29c0-1.711 1.268-3.005 3.473-3.005s3.474 1.294 3.474 3.005-1.175 2.988-3.474 2.988-3.473-1.285-3.473-2.988m5.619 0a2.146 2.146 0 1 0-2.146 2.077 1.959 1.959 0 0 0 2.146-2.077"
            transform="translate(-756.976 -252.905)"
            style={{ fill: color }}
          ></path>
          <path
            data-name="Path 13081"
            d="M953.077 283.159h-1.209v-5.789h2.852a4.2 4.2 0 0 1 1.932.306 1.461 1.461 0 0 1 .843 1.388 1.671 1.671 0 0 1-1.4 1.635l1.66 2.46h-1.43l-1.532-2.307h-1.72zm2.724-4.742a2.253 2.253 0 0 0-.9-.128h-1.822v1.643h1.847a1.894 1.894 0 0 0 .945-.17.73.73 0 0 0 .349-.673.682.682 0 0 0-.417-.672"
            transform="translate(-862.327 -253.888)"
            style={{ fill: color }}
          ></path>
          <path
            data-name="Path 13082"
            d="M1114.856 282.887a4.342 4.342 0 0 1-1.941.272h-2.946v-5.789h2.818a5.112 5.112 0 0 1 1.958.255 1.247 1.247 0 0 1 .766 1.209 1.337 1.337 0 0 1-.92 1.243 1.589 1.589 0 0 1 1.167 1.422 1.508 1.508 0 0 1-.9 1.388m-1-4.5a2.92 2.92 0 0 0-.953-.111h-1.737v1.464h1.7a3.025 3.025 0 0 0 .936-.1.628.628 0 0 0 .485-.656.582.582 0 0 0-.434-.6m.085 2.3a3.82 3.82 0 0 0-1.056-.094h-1.72v1.686h1.72a4.279 4.279 0 0 0 1.013-.085.741.741 0 0 0 .621-.775.753.753 0 0 0-.579-.732"
            transform="translate(-1005.556 -253.889)"
            style={{ fill: color }}
          ></path>
          <path
            data-name="Path 13083"
            d="M1214.315 283.159v-5.789h5.1v.928h-3.907v1.4h3.618v.919h-3.618v1.626h4.112v.911z"
            transform="translate(-1100.086 -253.888)"
            style={{ fill: color }}
          ></path>
          <path
            data-name="Path 13084"
            d="M1309.521 278.307v4.853h-1.221v-4.853h-2.214v-.936h5.644v.936z"
            transform="translate(-1183.221 -253.888)"
            style={{ fill: color }}
          ></path>
          <path
            data-name="Path 13085"
            d="M1402.282 278.307v4.853h-1.226v-4.853h-2.214v-.936h5.644v.936z"
            transform="translate(-1267.256 -253.888)"
            style={{ fill: color }}
          ></path>
          <path
            data-name="Path 13086"
            d="M1498.574 283.159v-5.789h5.1v.928h-3.908v1.4h3.618v.919h-3.618v1.626h4.112v.911z"
            transform="translate(-1357.605 -253.888)"
            style={{ fill: color }}
          ></path>
          <path
            data-name="Path 13087"
            d="M1598.518 283.159h-1.209v-5.789h2.852a4.2 4.2 0 0 1 1.932.306 1.461 1.461 0 0 1 .843 1.388 1.671 1.671 0 0 1-1.4 1.635l1.66 2.46h-1.43l-1.532-2.307h-1.72zm2.724-4.742a2.254 2.254 0 0 0-.9-.128h-1.822v1.643h1.847a1.894 1.894 0 0 0 .945-.17.73.73 0 0 0 .349-.673.682.682 0 0 0-.417-.672"
            transform="translate(-1447.052 -253.888)"
            style={{ fill: color }}
          ></path>
        </g>
      </g>
    </svg>
  );
};

export default SodastreamLogo;
